<script>
  import './header.css'
  import ConnectButton from '../ConnectButton.svelte'
  import Sidebar from '../sidebar/Sidebar.svelte'

  let logUrl = './images/logo.svg'
  let showNavbar = false
  const toggleNavBar = () => {
    showNavbar = !showNavbar
  }

</script>

<div class="header-wrapper flex justify-between items-center">
  <a href="/">
    <img class="header-logo" width="150" src={logUrl} alt="" />
  </a>
  <div class="button-wrapper flex items-center flex-text-center ml-auto">
    
    <!--{#if $location === '/permissionless' && $signerAddress}-->
    <!--  <a href="#/sale-listing">-->
    <!--    <button class="btn-gradient-border">My Projects</button>-->
    <!--  </a>-->
    <!--{:else}-->
    <!--  <a href="#/permissionless">-->
    <!--    <button class="btn-gradient-border">Create Project</button>-->
    <!--  </a>-->
    <!--{/if}-->
    <a id="explore-project" href="#/explore-projects?status=All&blockchain=All">Explore Projects</a>
    <a id="social-hive" href="https://socialhive.polinate.io/" target="_blank">
      <button class="btn-gradient-border">Social Hive</button>
    </a>
    <a id="header-start-project" href="#/start-project">
      <button class="btn-gradient-border btn-start-project">
        Start a Project
      </button>
    </a>
    <ConnectButton />
  </div>
  <div class="header-menu-button btn-gradient-border">
    <div
      class="hamburger-icon"
      class:change={showNavbar}
      on:click={toggleNavBar}>
      <div class="bar1" />
      <div class="bar2" />
      <div class="bar3" />
    </div>
  </div>
</div>
<Sidebar activeMenu={showNavbar} />
